// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3LqCw","title":"styles_title__CW-ga","price":"styles_price__1yTgp","final":"styles_final__2_P-D"};